import { combineReducers } from 'redux';
import { cart } from './Reducers/Cart.reducer';
import { quickSearch } from './Reducers/QuickSearch.reducer';
import { navigation } from './Reducers/Navigation.reducer';
import { facetedSearch } from './Reducers/FacetedSearch.reducer';
import { myPage } from './Reducers/MyPage.reducer';
import { checkout } from './Reducers/Checkout.reducer';
import { lightboxImages } from './Reducers/LightboxImages.reducer';
import { sizeGuide } from './Reducers/SizeGuide.reducer';
import { registerMe } from './Reducers/RegisterMe.reducer';
import { sizeInput } from './Reducers/PurchaseMultiSizeInput.reducer';
import { quotation } from './Reducers/Quotation.reducer';

const app = combineReducers({
    cart,
    checkout,
    quickSearch,
    navigation,
    myPage,
    facetedSearch,
    lightboxImages,
    sizeGuide,
    registerMe,
    sizeInput,
    quotation,
});

export default app;
